import { InputAdornment, TextField } from "@mui/material"

let scrolling = false
const OneTextArea = ({
    name = "",
    defaultValue,
    rows = 4,
    StartIcon = false,
    EndIcon = false,
    IconCallback = false,
    readOnly = false,
    disabled = false,
    autoScroll = false,
    contador = false,
    maxlength,
    fontSize = "12px",
    newSx = {},
    ...rest
}) => {
    // AutoScroll
    if (autoScroll && rest && rest.id) {
        let textarea = document.getElementById(rest.id)
        if (
            textarea &&
      textarea.selectionStart == textarea.selectionEnd &&
      !scrolling
        ) {
            scrolling = setTimeout(() => {
                clearTimeout(scrolling)
                scrolling = false
                textarea.scrollTop = textarea.scrollHeight
            }, 500)
        }
    }

    return (
        <>
            <TextField
                variant="outlined"
                sx={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: disabled ? "#c9c7c7" : "#fff",
                    borderRadius: "5px",
                    border: "none",
                    "& fieldset": { border: "none" },
                    ...newSx
                }}
                name={name}
                disabled={disabled}
                {...rest}
                defaultValue={defaultValue || ""}
                // rows={rows}
                multiline={true}
                inputProps={{
                    readOnly,
                    maxLength: maxlength,
                    style: {
                        height: "100%",
                        fontWeight: '600'
                        // overflowY: 'auto'
                    },
                    sx: {
                        padding: "3px",
                        overflowY: "scroll !important",
                        position: "relative",
                        // padding: 0,

                        border: "none",
                        "& fieldset": { border: "none" },
                        margin: "0 !important",
                        // overflowY: 'scroll',
                        "&::-webkit-scrollbar": {
                            width: "7px",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            cursor: "pointer"
                        },
                        "&::-webkit-scrollbar-thumb": {
                            borderRadius: "10px",
                            webkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                            cursor: "pointer"
                        },
                        "&::-webkit-scrollbar-track": {
                            webkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
                            borderRadius: "10px",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            cursor: "pointer"
                        },
                        "::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "rgba(0,0,0,0.5)",
                            cursor: "pointer"
                        }
                    }
                }}
                InputProps={{
                    sx: {
                        height: "100% !important",
                        padding: "3px",
                        // padding: 0,
                        margin: "0 !important",
                        border: "none",
                        "& fieldset": { border: "none" },
                        fontSize
                    },
                    startAdornment: StartIcon && (
                        <InputAdornment position="start">
                            <StartIcon onClick={() => IconCallback()} />
                        </InputAdornment>
                    ),
                    endAdornment: EndIcon && (
                        <InputAdornment position="start" style={{ position: "relative" }}>
                            <EndIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => IconCallback()}
                            />
                        </InputAdornment>
                    )
                }}
            />
            {
                contador && (
                    <div style={{ marginTop: '10px' }}>
                        {defaultValue ? maxlength - defaultValue.length : maxlength }
                        / { maxlength } Caracteres Restantes
                    </div>
                )
            }
        </>
    )
}

export default OneTextArea

// /* Tutorial:
//     As props para passar para o input são:
//         - StartIcon: Icone que irá aparecer no começo do input. Deve ser passado apenas o nome do icone
//         e ser importado onde está sendo chamado o input. ex: StartIcon={Apartment}
//         - EndIcon: Mesmo que o StartIcon mas para o Fim.
//         - name: nome da propriedade que será afetada no objeto form.
//         - type: Tipo do componente. Caso não seja passado o default é text
// */
